import jwtDecode from 'jwt-decode'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { AuthUserController } from 'infraestructure/controllers/authUserController'
import { Representative } from 'domain/models/authUser'
import { AuthLoginRepresentativeRequest } from 'domain/entities/authUser'
import { Status } from 'domain/models/apiResponse'
import {
  authUserState,
  loginError,
  loginStart,
  loginSuccess,
} from 'presentation/redux/slices/authUserSlice'
import { accessTokenKey, representativeKey } from 'presentation/constant/localStorageKeys'
import { urlRoutes } from 'presentation/routes/config/urlRoutes/urlRoutes'
import useSessionStorage from 'presentation/hooks/useSessionStorage'
import useError from 'presentation/hooks/useError'

export const useLogin = () => {
  const dispatch = useDispatch()
  const { isLoading, error } = useSelector(authUserState)
  const navigate = useNavigate()
  const { saveDataAtSessionStorage } = useSessionStorage(representativeKey)
  const { getErrorMessage } = useError()

  const login = async (data: AuthLoginRepresentativeRequest) => {
    dispatch(loginStart())
    try {
      const response = await AuthUserController.login(data)
      if (response?.status === Status.success) {
        const token = response?.data?.access_token as string
        const decodeToken = jwtDecode<Representative>(token)
        const userData = {
          logged: true,
          refreshToken: response?.data?.refresh_token,
          refreshExpiresIn: response?.data?.refresh_expires_in,
          representative: decodeToken,
        }
        saveDataAtSessionStorage({ data: userData })
        sessionStorage.setItem(
          accessTokenKey,
          JSON.stringify({
            accessToken: token,
            accessExpiresIn: response?.data?.access_expires_in,
          }),
        )
        const payload = {
          ...userData,
          token,
          accessExpiresIn: response?.data?.access_expires_in,
        }
        dispatch(loginSuccess(payload))
        const redirectRoute = decodeToken?.firstLogin
          ? urlRoutes.public.auth.createPassword.urlTo
          : urlRoutes.private.goalAssignment.urlTo
        navigate(redirectRoute)
      }
    } catch (err: any) {
      dispatch(loginError(getErrorMessage({ error: err })))
    }
  }
  return { login, isLoading, error }
}
